import axios from 'axios';
import Store from './Store';
import { applyBearerOrCookie } from './authStrategy';

function withAuth(config) {
  return applyBearerOrCookie(config, Store.getToken());
}

export default {
  name: 'RulesService',
  rules: [
  ],
  findRulesByTerm(term, paramsPage) {
    paramsPage.append('term', term);

    return axios(withAuth({
      url: `${process.env.VUE_APP_DRIVE_SERVICE_URL}/rules`,
      method: 'get',
      params: paramsPage,
    }));
  },
  findRulesByTermAndGroup(term, groupID, paramsPage) {
    paramsPage.append('term', term);
    paramsPage.append('groupID', groupID);

    return axios(withAuth({
      url: `${process.env.VUE_APP_DRIVE_SERVICE_URL}/rules/findAllByTermAndGroup`,
      method: 'get',
      params: paramsPage,
    }));
  },
  create(rule) {
    return axios(withAuth({
      url: `${process.env.VUE_APP_DRIVE_SERVICE_URL}/rules`,
      method: 'post',
      data: rule,
    }));
  },
  update(rule) {
    return axios(withAuth({
      url: `${process.env.VUE_APP_DRIVE_SERVICE_URL}/rules/${rule.id}`,
      method: 'put',
      data: rule,
    }));
  },
  delete(rule) {
    return axios(withAuth({
      url: `${process.env.VUE_APP_DRIVE_SERVICE_URL}/rules/${rule.id}`,
      method: 'delete',
    }));
  },
  changeSort(idRule, newSortValue) {
    return axios(withAuth({
      url: `${process.env.VUE_APP_DRIVE_SERVICE_URL}/rules/change-sort`,
      method: 'put',
      data: {
        idRuleDrive: idRule,
        newSort: newSortValue,
      },
    }));
  },
  findAllRuleGroups() {
    return axios(withAuth({
      url: `${process.env.VUE_APP_DRIVE_SERVICE_URL}/rule_drive_group`,
      method: 'get',
    }));
  },
  findAllProfiles() {
    const promise = new Promise((resolve, reject) => {
      axios(withAuth({
        url: `${process.env.VUE_APP_SECURITY_SERVICE_URL}/profile`,
        method: 'get',
      }))
        .then((response) => {
          const retList = [];
          response.data.forEach((element) => {
            retList.push({
              id: element.id,
              description: element.name,
            });
          });
          resolve(retList);
        })
        .catch((e) => {
          reject(e);
        });
    });

    return promise;
  },

  findAllGroups() {
    const promise = new Promise((resolve, reject) => {
      axios(withAuth({
        url: `${process.env.VUE_APP_SECURITY_SERVICE_URL}/group`,
        method: 'get',
      }))
        .then((response) => {
          const retList = [];
          if (!response) {
            reject(response);
            return;
          }
          response.data.forEach((element) => {
            retList.push({
              id: element.id,
              description: element.name,
            });
          });
          resolve(retList);
        })
        .catch((e) => {
          reject(e);
        });
    });

    return promise;
  },

  findUserByTerm(term, paramsPage) {
    paramsPage.append('term', term);
    const promise = new Promise((resolve, reject) => {
      axios(withAuth({
        url: `${process.env.VUE_APP_SECURITY_SERVICE_URL}/user/findAllByTerm`,
        method: 'get',
        params: paramsPage,
      }))
        .then((response) => {
          const retList = [];
          response.data.content.forEach((element) => {
            retList.push({
              id: element.id,
              description: element.login,
            });
          });
          resolve({
            content: retList,
            searchPagination: {
              page: response.data.pageable.pageNumber + 1,
              rowsPerPage: response.data.pageable.pageSize,
              totalItems: response.data.totalElements,
            },
          });
        })
        .catch((e) => {
          reject(e);
        });
    });

    return promise;
  },
};
